import React from 'react'

const SecExtra = () => {
  return (
    <>
      <div className="relative text-center py-7 px-10 bg-transparent backdrop-blur-xl">
        <p className="relative text-3xl font-medium text-[#192027] mb-9">
          Experience the Convenience … Get the demo today
        </p>
        <div className="pb-8">
          <a
            href="https://www.easyofficesoftware.com/public/demo/demo/EasyOfficeDemoSetup.exe"
            target="_blank"
            rel="noreferrer"
            className="sm:px-20 px-6 py-2 sm:py-4 bg-gradient-to-r from-[#686bff] to-[#00b812] text-white rounded-lg text-2xl font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
          >
            Download Demo
          </a>
        </div>
      </div>
    </>
  );
}

export default SecExtra;